import { ReactComponent as IconFacebook } from 'approot/shared/layout/footer/social/facebook.svg';
import { ReactComponent as IconInstagram } from 'approot/shared/layout/footer/social/instagram.svg';

export const inlineSvgMapping = {
  icon_facebook: IconFacebook,
  icon_instagram: IconInstagram,
};

export type SocialSvgIds = keyof typeof inlineSvgMapping;

type Props = {
  id: SocialSvgIds;
  width?: string | number;
  height?: string | number;
};

const SocialInlineSvg = (props: Props) => {
  const Svg = inlineSvgMapping[props.id];
  return (
    <Svg
      focusable="false"
      width={props.width || 16}
      height={props.height || 16}
      {...props}
    />
  );
};

export default SocialInlineSvg;
